import {ToolbarButton} from "app/Interface/Component/Buttons"
import React from "react"
import {Button} from "react-bootstrap"
import {useTranslation} from "react-i18next"

function CancelButton({id, onClick, disabled}: ToolbarButton) {
  const {t} = useTranslation('Components.Buttons')
  return (
    <Button
      id={`cancel-${id}`}
      onClick={onClick}
      variant={'warning'}
      disabled={disabled}
    >
      {t('cancel')}
    </Button>
  )
}

export default CancelButton
